/**
 * Returns true when the UI should show developer/diagnostic surfaces.
 * Gated behind: DEV mode OR VITE_SHOW_DIAGNOSTICS === "true"
 */
export function showDiagnostics(): boolean {
  return import.meta.env.DEV || import.meta.env.VITE_SHOW_DIAGNOSTICS === 'true';
}
